import { UserObjectGroupAcl } from "app/models/UserObjectGroupAcl";

export interface ObjectGroupAclGroupItem {
  value: UserObjectGroupAcl;
  label: string;
}

export interface ObjectGroupAclGroup {
  key: string;
  title: string;
  items: ObjectGroupAclGroupItem[];
}

export interface ObjectGroupAclPreset {
  label: string;
  mask: number;
}

export const OBJECT_GROUP_ACL_GROUPS: ObjectGroupAclGroup[] = [
  {
    key: "objects",
    title: "Object permissions",
    items: [
      { value: UserObjectGroupAcl.EditObjects, label: "Edit objects" },
      { value: UserObjectGroupAcl.ChangeImei, label: "Edit IMEI" },
      { value: UserObjectGroupAcl.DeleteObjects, label: "Delete objects" },
      { value: UserObjectGroupAcl.SendCommands, label: "Send commands" }
    ]
  },
  {
    key: "group",
    title: "Group permissions",
    items: [
      { value: UserObjectGroupAcl.EditGroup, label: "Edit group" },
      { value: UserObjectGroupAcl.ManageMembers, label: "Manage members" },
      { value: UserObjectGroupAcl.DeleteGroup, label: "Delete group" }
    ]
  }
];

export function getObjectGroupFullAccessMask(): number {
  return [
    UserObjectGroupAcl.EditObjects,
    UserObjectGroupAcl.ChangeImei,
    UserObjectGroupAcl.DeleteObjects,
    UserObjectGroupAcl.SendCommands,
    UserObjectGroupAcl.EditGroup,
    UserObjectGroupAcl.ManageMembers,
    UserObjectGroupAcl.DeleteGroup
  ].reduce((acc, v) => acc | v, 0);
}

export function getObjectGroupAclPresets(): ObjectGroupAclPreset[] {
  const fullMask = getObjectGroupFullAccessMask();
  return [
    { label: "No access", mask: 0 },
    { label: "Full access", mask: fullMask }
  ];
}
